<template>
  <div>
    <div v-if="!isMobile">
      <div v-if="loaded" class="header">
        <img class="logo-l" src="../assets/logo-cna.png" alt="">
        <img v-if="isCambridgeType && hasLogo" class="logo-r" src="../assets/logo-cambridge.png" alt="Logo de Cambridge">
        <img v-if="!isCambridgeType && hasLogo" class="logo-r" src="../assets/logo-siele.png" alt="Logo do SIELE">
      </div>
      <div>
        <loader></loader>
        <component
          v-if="loaded"
          :is="currentComponent"
          :simulado="simulado"
          :locked="lockedMode"></component>

        <modal :show.sync="modal.show" :callback="modal.callback">
          <div slot="body">
            <p>
              {{ modal.message }}
            </p>
          </div>
        </modal>

        <modal :show.sync="aviso.show" :buttons="false">
          <div slot="body">
            <p>
              {{ aviso.message }}
            </p>
          </div>
        </modal>
      </div>
    </div>
    <mobile v-if="isMobile"></mobile>
  </div>
</template>

<script>

  import http from '../http/axios.js'
  import hello from './start/Hello.vue'
  import modal from './ui/Modal'
  import error from './result/error.vue'
  import perguntas from './perguntas/Perguntas.vue'
  import resultado from './result/Resultado.vue'
  import bus from '@/bus/event-bus.js'
  import store from '@/domain/store.js'
  import loader from './ui/LoadingBar'
  import parser from '@/domain/token-parser.js'
  import mobile from './start/Mobile.vue'

  export default {

    props: {
      token: {
        default: null
      }
    },

    data() {
      return {
        loaded: false,
        simulado: null,
        lockedMode: false,
        hasInternetConnection: true,
        failedRequestCount: 0,
        isAudioPlaying: false,
        internetCheckTimeout: null,
        modal: {
          show: false,
          message: '',
          callback: function () {
          }
        },
        aviso: {
          show: false,
          message: ''
        }
      }
    },

    mounted() {


      this.registerEvents()

      this.getStatus().then(() => {
        this.checkForLockedMode(this.simulado.Ref)
        this.setStore()
        if (this.simulado.IniciouSimulado) {
          this.acessou().then(() => {
            this.loaded = true
          })
        } else {
          this.loaded = true
        }
      })
    },

    computed: {

      hasLogo() {
        return this.simulado.SimuladoTipo !== 3;
      },

      isCambridgeType() {
        return this.simulado.SimuladoTipo === 1;
      },

      isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      },
      currentComponent() {

        if (this.lockedMode) {
          return "perguntas";
        }

        if (this.simulado.FinalizouSimulado) {
          return "resultado"
        }

        if (this.simulado.Bloqueado) {
          return "error"
        }

        if (this.simulado.SuperouLimiteAcessos) {
          return "error"
        }

        if (this.simulado.TempoAcabou) {
          return "resultado"
        }

        if (!this.simulado.PodeIniciar) {
          return "error"
        }

        if (this.simulado.PrazoAcabou) {
          return "error"
        }

        if (!this.simulado.IniciouSimulado) {
          return "hello"
        }


        if (this.simulado.IniciouSimulado) {
          return "perguntas"
        }

        return ""
      }
    },

    components: {
      mobile,
      hello,
      perguntas,
      error,
      resultado,
      loader,
      modal
    },

    methods: {

      checkForLockedMode(cpf) {
        var urlParams = new URLSearchParams(window.location.search);
        var e = urlParams.get('e');
        console.log(e);
        this.lockedMode = parser.validate(e, cpf)
      },

      registerEvents() {

        bus.$on('part.changed', (prevPart, part) => {
          this.modal.show = false
          this.pingPart(prevPart)
        })

        this.loadingTimeout = null
        bus.$on('loading', (l) => {
          if (this.hasInternetConnection) {
            if (l) {
              if (this.loadingTimeout == null) {
                this.loadingTimeout = setTimeout(() => {
                  this.showAviso("Aguarde...")
                }, 4000)
              }
            }

            if (!l) {
              this.aviso.show = false
              clearTimeout(this.loadingTimeout)
              this.loadingTimeout = null
            }
          }
        })

        bus.$on('request.failed', () => {
          this.failedRequestCount++;
          if (this.failedRequestCount === 3) {
            if (this.hasInternetConnection) {
              this.hasInternetConnection = false
              this.showAviso("Por favor, tente novamente mais tarde.")
            }
          }
        })

        bus.$on('audio.played', (prevPart, part) => {
          this.pingAudio(prevPart)
        })

        bus.$on('respondeu', (opcaoId, perguntaId) => {

          this.respondeu(opcaoId, perguntaId)
        })

        bus.$on('started', (opcaoId) => {
          this.acessou()
        })

        bus.$on('finalizou', () => {
          this.finalizou()
        })

        bus.$on('relogio.ping', () => {
          this.ping()
        })

        bus.$on('relogio.acabou', () => {
          this.finalizar()
        })

        bus.$on('show.message', (message, callback) => {
          this.modal.show = true;
          this.modal.message = message;
          this.modal.callback = callback;
        })
      },

      setStore() {
        store.ultimaPart = this.simulado.Parts.length
      },

      getStatus() {
        var data = {
          id: this.token
        }

        return http.post('status', data).then((r) => {
          this.$set(this, 'simulado', r.data)
        })
      },

      updatePart(data) {
        const parts = this.simulado.Parts.map((i) => {
          if (i.PartId == data.PartId) {
            return data;
          }

          return i;
        })
        this.$set(this.simulado, 'Parts', parts)
      },

      pingAudio(part) {
        var data = {
          PartId: part.PartId,
          InscritoId: this.token
        }

        if (this.lockedMode) return;

        setTimeout(() => {
          http.post('audio-ping', data).then((r) => {
            this.updatePart(r.data)
          })
        }, 700)

      },

      ping() {

        var data = {
          InscritoId: this.token
        }

        if (this.lockedMode) return;

        http.post('ping', data).then((r) => {
          this.$set(this, 'simulado', r.data)
        })
      },

      pingPart(part) {

        var data = {
          PartId: part.PartId,
          InscritoId: this.token
        }

        if (this.lockedMode) return;

        http.post('ping-part', data).then((r) => {
          this.updatePart(r.data)
        })
      },

      respondeu(opcaoId, perguntaId) {
        var data = {
          OpcaoId: opcaoId,
          InscritoId: this.token,
          PerguntaId: perguntaId
        }

        if (this.lockedMode) return;

        http.post('responder', data).then((r) => {
        })
      },

      showAviso(message) {
        this.aviso.show = true
        this.aviso.message = message
      },

      hideAviso() {
        this.aviso.show = false
      },

      acessou() {

        var data = {
          InscritoId: this.token
        }

        return http.post('acessou', data).then((r) => {
          this.$set(this, 'simulado', r.data)
        })
      },

      finalizar() {
        var data = {
          InscritoId: this.token
        }

        if (this.lockedMode) return;

        this.modal.show = false

        return http.post('finalizou', data).then((r) => {
          this.$set(this, 'simulado', r.data)
        })
      },

      finalizou() {
        bus.$emit('show.message', "Você deseja realmente finalizar o simulado?", () => {
          this.finalizar()
        });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Simulado.vue